const STORAGE_KEY = "internal-transfer-intents";

const readIntents = () => {
  const entries = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "[]");
  if (!Array.isArray(entries)) throw new Error("Invalid transfer request storage");
  return entries;
};

export const getTransferRequestKey = (customerId, data) => {
  const signature = JSON.stringify([
    customerId,
    data.fromId,
    data.toId,
    String(Number(data.amount)),
    data.baseCurrency,
    data.targetCurrency,
    data.source,
    data.destination,
    Boolean(data.isClientToClient),
    data.note || "",
  ]);
  const intents = readIntents();
  const existing = intents.find((entry) => entry.signature === signature);
  if (existing) return existing.key;
  const bytes = window.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("");
  const key = `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  intents.push({
    signature,
    key 
  });
  // Do not submit if the key cannot be persisted for a retry after a reload.
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(intents));
  return key;
};

export const clearTransferRequestKey = (key) => {
  if (!key) return;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(readIntents().filter((entry) => entry.key !== key)));
};
